export var IDENTIFIER_TOOLTIP = 'tooltip';
